import $ from 'jquery'
import {Core} from "../../../assets/src/scripts/core.js";

export class PostsList {
  constructor($container) {
    this.classes = {
      title: 'posts-list-content',
      slider: 'posts-list-slider',
    }
    this.$container = $container
    this.$slider = $container.find(`.${this.classes.slider}`)
    this.$window = $(window)
    this.sliderTitle = ''
    this.bp = 'md'

    if (this.$slider.length) {
      this.getTitleSlide()

      if (this.sliderTitle.length) {
        this.onResize()
        this.$window.on('resize', this.onResize.bind(this))
      }
    }
  }

  existTitleOnSlide() {
    return !! this.$slider.find(`.${this.classes.title}`).length
  }

  existTitleOnCurrentSlide(index, slide) {
    return ! $(slide).find(`.${this.classes.title}`).length
  }

  existTitleUpToSlider() {
    return !! this.$container.find(`.${this.classes.title}:not(.${this.classes.slider} *)`).length
  }

  getTitleSlide() {
    if (this.existTitleOnSlide()) {
      this.sliderTitle = this.$slider.find(`.${this.classes.title}`).clone()
    }
  }

  onResize() {
    if (Core.isBpLessThan(this.bp)) {
      if (! this.existTitleUpToSlider()) {
        this.$container.find('> div').prepend(this.sliderTitle)
      }

      if (this.existTitleOnSlide()) {
        this.$slider.slick('slickRemove', 0)
      }
    } else if (Core.isBpGreaterThan(this.bp)) {
      if (this.existTitleUpToSlider()) {
        this.$container.find(`.${this.classes.title}:not(.${this.classes.slider} *)`).remove()
      }

      if (! this.existTitleOnSlide()) {
        this.$slider.slick('slickAdd', '<div><div>' + this.sliderTitle.prop('outerHTML') + '</div></div>', true)
      }
    }
  }
}
